<script>
    export let icon,
        name,
        detail,
        bg = undefined,
        details = undefined;
</script>

<style>
    .main {
        padding: 40px 40px 10px 40px;
        max-width: 900px;
        margin: auto;
        display: flex;
        align-items: center;
        flex-direction: row;
    }
    .icon {
        height: 116px;
        width: 116px;
        padding-right: 16px;
        padding-bottom: 8px;
        padding-top: 8px;
        display: block;
    }
    .learn-more {
        min-width: 130px;
        margin-top: 5px;
        margin-bottom: 5px;
    }
    @media only screen and (max-width: 768px) {
        .main {
            padding: 40px 10px 10px 10px;
            align-items: flex-start;
            flex-direction: column;
        }
        .learn-more {
            align-self: stretch;
        }
    }
</style>

<div class={bg}>
    <div class="main">
        <!-- svelte-ignore a11y-img-redundant-alt -->
        <img class="icon" src={icon} alt="App Icon"/>
        <div style="margin-right: 16px;">
            <div
                class="ea-bold"
                style="font-size: 27px; line-height: 26px; color: #000; padding-bottom: 4px;">
                {@html name}
            </div>
            <div
                class="ea-light"
                style="font-size: 19px; line-height: 21px; flex: 0 0 100%">
                {@html detail}
            </div>
        </div>
        {#if details}
            <div style="flex: 1" />
            <a href={details} target="__blank" rel="noopener">
                <button class="learn-more" on:click={details}>
                    Learn More
                </button>
            </a>
        {/if}
    </div>
</div>
